<template>
  <el-select
    v-model="selected"
    placeholder="选择项目"
    size="small"
    class="project-switcher"
    filterable
    @change="onChange"
  >
    <el-option
      v-for="item in projects"
      :key="String(item.id)"
      :label="item.name"
      :value="String(item.id)"
    />
  </el-select>
</template>

<script>
import { areaApi } from '@/api/archives';

export default {
  name: 'ProjectSwitcher',
  data() {
    return {
      projects: [],
      selected: this.$store.state.currentProjectId ? String(this.$store.state.currentProjectId) : ''
    };
  },
  created() {
    this.loadProjects();
    this.$root.$on('projects-changed', this.onProjectsChanged);
    this.$root.$on('role-changed', this.loadProjects);
  },
  beforeDestroy() {
    this.$root.$off('projects-changed', this.onProjectsChanged);
    this.$root.$off('role-changed', this.loadProjects);
  },
  watch: {
    '$store.state.currentProjectId'(id) {
      this.selected = id ? String(id) : '';
    }
  },
  methods: {
    async loadProjects(preferId) {
      const data = await areaApi.options();
      this.projects = data || [];
      const ids = this.projects.map((p) => String(p.id));
      let next = preferId != null ? String(preferId) : this.selected;
      if (next && !ids.includes(next)) {
        next = '';
      }
      if (!next && this.projects.length) {
        next = String(this.projects[0].id);
      }
      if (next) {
        this.selected = next;
        this.onChange(next);
      } else {
        this.selected = '';
        this.$store.commit('setCurrentProject', { id: '', name: '' });
      }
    },
    onProjectsChanged(payload) {
      const preferId = payload && payload.id != null ? payload.id : undefined;
      this.loadProjects(preferId);
    },
    onChange(id) {
      const proj = this.projects.find((p) => String(p.id) === String(id));
      this.$store.commit('setCurrentProject', { id, name: proj ? proj.name : '' });
      this.$root.$emit('project-changed', id);
    }
  }
};
</script>

<style lang="scss" scoped>
.project-switcher {
  width: 220px;
}
</style>
